var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('transition',{attrs:{"name":"fade","appear":"","appear-active-class":"fade-enter-active"}},[(_vm.apiLoaded)?_c('v-container',[_c('h1',[_c('span',[_vm._v("Заявки")])]),_c('Register',{ref:"registerComponent",attrs:{"config":_vm.regConfig}})],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }